import { createReducer, on } from '@ngrx/store';
import { PrizeRequestModel } from '../../_models/prize-request.model';
import { PrizeRequestsActions } from '../_actions/prize-requests.actions';

export interface PrizeRequestsState {
  list: {
    filters: any;
    data: ReadonlyArray<PrizeRequestModel>;
    total: number;
  };
  selected: PrizeRequestModel | null;
}

export const initialPrizeRequestsState: PrizeRequestsState = {
  list: {
    filters: {},
    data: [],
    total: 0,
  },
  selected: null,
};

export const prizeRequestsReducer = createReducer(
  initialPrizeRequestsState,

  // Load list
  on(PrizeRequestsActions.loadPrizeRequests, (state, { filters }) => ({
    ...state,
    list: {
      ...state.list,
      filters,
    },
  })),
  on(PrizeRequestsActions.loadPrizeRequestsSuccess, (state, { items, total }) => ({
    ...state,
    list: {
      ...state.list,
      data: items,
      total,
    },
  })),
  on(PrizeRequestsActions.loadPrizeRequestsFailure, (state) => state),

  // Load by ID
  on(PrizeRequestsActions.loadPrizeRequestById, (state) => state),
  on(PrizeRequestsActions.loadPrizeRequestByIdSuccess, (state, { item }) => ({
    ...state,
    selected: item,
  })),
  on(PrizeRequestsActions.loadPrizeRequestByIdFailure, (state) => state),

  // Approve
  on(PrizeRequestsActions.approvePrizeRequest, (state) => state),
  on(PrizeRequestsActions.approvePrizeRequestSuccess, (state, { item }) => ({
    ...state,
    selected: item,
    list: {
      ...state.list,
      data: state.list.data.map((r) => (r.id === item.id ? item : r)),
    },
  })),
  on(PrizeRequestsActions.approvePrizeRequestFailure, (state) => state),

  // Reject
  on(PrizeRequestsActions.rejectPrizeRequest, (state) => state),
  on(PrizeRequestsActions.rejectPrizeRequestSuccess, (state, { item }) => ({
    ...state,
    selected: item,
    list: {
      ...state.list,
      data: state.list.data.map((r) => (r.id === item.id ? item : r)),
    },
  })),
  on(PrizeRequestsActions.rejectPrizeRequestFailure, (state) => state),

  // Deliver
  on(PrizeRequestsActions.deliverPrizeRequest, (state) => state),
  on(PrizeRequestsActions.deliverPrizeRequestSuccess, (state, { item }) => ({
    ...state,
    selected: item,
    list: {
      ...state.list,
      data: state.list.data.map((r) => (r.id === item.id ? item : r)),
    },
  })),
  on(PrizeRequestsActions.deliverPrizeRequestFailure, (state) => state),

  // Clear selected
  on(PrizeRequestsActions.clearSelectedPrizeRequest, (state) => ({
    ...state,
    selected: null,
  }))
);
